// Tüm endpoint'ler artık tek merkezi `rootApi` üzerine inject ediliyor (bkz. ./rootApi).
// Geliştirici rehberi: docs/RTK_QUERY_API.md
// Bu barrel yalnızca otomatik üretilen hook'ları yeniden dışa aktarır; ayrı
// reducer/middleware kaydı yapılmaz (store sadece rootApi'yi kaydeder).
//
// Aşağıdaki iki API nesnesi, `export const { ... } = xApi` formundaki hook
// üretimleri için import edilir; geri kalan tüm hook'lar `export ... from`
// ile yeniden dışa aktarılır (bu da ilgili endpoint modülünün yüklenip
// rootApi'ye inject edilmesini tetikler).
import { preApprovalApi } from './endpoints/preApproval';
import { dealerInvoiceEntryApi } from './endpoints/dealerInvoiceEntryApi';

// Export auth API hooks
export { useLoginMutation, useForgotPasswordMutation, useResetPasswordMutation, useLogoutMutation, useRefreshTokenMutation } from './endpoints/auth';

//Export Announcement API hooks
export {
    useGetAllQuery,
    useCreateAnnouncementMutation,
    useUpdateAnnouncementMutation,
    usePublishAnnouncementMutation,
    useUpdateAnnouncementReadStatusMutation,
    useDeleteAnnouncementMutation,
    useUploadAnnouncementDocumentMutation,
    useGetAnnouncementDocumentsByIdQuery,
    useDeleteAnnouncementDocumentMutation,
    useGetAnnouncementByDealerIdQuery,
    useGetUnreadAnnouncementCountQuery
} from './endpoints/announcements';

// Export preApproval API hooks
export const {
    useGetAllPreApprovalsQuery,
    useGetPreApprovalByIdQuery,
    useCreatePreApprovalMutation,
    useUpdatePreApprovalMutation,
    useDeletePreApprovalMutation,
    useChangePreApprovalStatusMutation,
    useGetPreApprovalHistoryQuery,
    useUploadPreApprovalDocumentMutation,
    useGetPreApprovalDocumentsByIdQuery,
    useLazyGetPreApprovalDocumentsByIdQuery,
    useDeletePreApprovalDocumentMutation,
    useLazyDownloadPreApprovelDocumentQuery,
    useGetPreApprovalCountBySapDealerIdQuery,
    useGetPreApprovalDropdownQuery,
    useGetPreApprovalCommentsQuery
} = preApprovalApi;

export { useGetLaborCatalogQuery, useGetLaborCatalogByIdQuery, useCreateLaborCatalogMutation, useUpdateLaborCatalogMutation, useDeleteLaborCatalogMutation } from './endpoints/laborCatalog';

export { useGetUserAccountsQuery, useCreateUserAccountMutation, useGetUserByIdQuery, useUpdateUserAccountMutation, useDeleteUserAccountMutation } from './endpoints/userAccount';

export { useGetFaultClientDefinitionsQuery, useCreateFaultClientDefinitionMutation, useUpdateFaultClientDefinitionMutation, useDeleteFaultClientDefinitionMutation, useGetFaultClientDefinitionByIdQuery } from './endpoints/faultClientDefinitions';

export { useGetProductGroupsQuery } from './endpoints/productgroups';

export { useGetClaimLimitsQuery, useCreateClaimLimitMutation, useUpdateClaimLimitMutation, useDeleteClaimLimitMutation } from './endpoints/claimLimitApi';

// Export user favorites API hooks
export { useGetMyFavoritesQuery, useLazyGetMyFavoritesQuery, useAddFavoriteMutation, useDeleteFavoriteMutation, useReorderFavoritesMutation } from './endpoints/userFavorites';

// Export dealer API hooks
export { useGetAllDealersQuery, useGetDealerByIdQuery, useCreateDealerMutation, useUpdateDealerMutation, useDeleteDealerMutation } from './endpoints/dealer';

export {
    useGetPartsDealerBrandMatchListQuery,
    useGetPartsDealerBrandMatchByIdQuery,
    useGetPartsDealerBrandMatchDealerDropdownQuery,
    useGetPartsDealerBrandMatchBrandDropdownQuery,
    useSavePartsDealerBrandMatchMutation,
    useUpdatePartsDealerBrandMatchVisibilityMutation,
    useDeletePartsDealerBrandMatchMutation
} from './endpoints/partsDealerBrandMatch';

export { useGetAllBrandsQuery, useUpdateBrandMutation } from './endpoints/brand';

export { useGetAllModelsQuery, useGetAllModelDropdownListQuery } from './endpoints/model';

// Export compound API hooks
export {
    useGetChassisDropdownListQuery,
    useGetChassisDropdownListWithExternalQuery,
    useGetFaultModesDropdownListQuery,
    useGetDealerAgreementTypeQuery,
    useGetForeignMainDealerDropdownQuery,
    useGetSapDealerByCountryDropdownQuery,
    useLazyGetSapDealerByCountryDropdownQuery,
    useGetCanUseFullServiceDealerDropdownQuery
} from './endpoints/compound';

// Export sap API hooks
export { useGetItemCodesQuery, useLazyGetItemCodesQuery, useGetWarrantyClaimsItemDropdownQuery, useGetMeasureListQuery, useGetExchangeRateListQuery } from './endpoints/sap';

// Export faultcodes API hooks
export {
    useGetMainCategoriesQuery,
    useGetSecondCategoriesQuery,
    useGetSubCategoriesQuery,
    useGetSubPartCategoriesQuery,
    useGetFailureModesCategoryQuery,
    useGetTranslationListQuery,
    useUpdateMainCategoriesMutation,
    useUpdateSecondCategoriesMutation,
    useUpdateSubCategoriesMutation,
    useUpdateSubPartCategoriesMutation,
    useUpdateFailureModesCategoryMutation,
    // Eksik hook'lar eklendi:
    useAddMainCategoriesMutation,
    useAddSecondCategoriesMutation,
    useAddSubCategoriesMutation,
    useAddSubPartCategoriesMutation,
    useAddFailureModesCategoryMutation,
    useGetCategoryByIdQuery,
    useDeleteFaultCodesMutation
} from './endpoints/faultcodes';

// Export dealerAddressPriceList API hooks

export {
    useGetDealerAddressPriceListQuery,
    useAddDealerAddressPriceListMutation,
    useUpdateDealerAddressPriceListMutation,
    useDeleteDealerAddressPriceListMutation,
    useGetDealerAddressPriceListDropdownQuery,
    useGetDealerAddressPriceListByIdQuery
} from './endpoints/priceList';

// Export dealer address API hooks
export { useGetAllDealerAddressQuery, useCreateDealerAddressMutation, useUpdateDealerAddressMutation, useGetByDealerIdQuery, useDeleteDealerAddressMutation, useGetDealerAddressByDealerIdQuery } from './endpoints/dealeraddress';

export { useLazyGetVehicleDetailInformationQuery } from './endpoints/vehicleDetailInformation';

export { useGetAllDealerAddressBrandQuery, useCreateDealerAddressBrandMutation, useUpdateDealerAddressBrandMutation, useGetByIdDealerAddressBrandQuery } from './endpoints/dealerAddressBrand';

export { useGetAllDealerAddressBrandPaymentQuery, useCreateDealerAddressBrandPaymentMutation, useUpdateDealerAddressBrandPaymentMutation, useGetDealerPaymentCurrencyQuery } from './endpoints/dealerAddressBrandPayment';

export { useGetAllDealerAddressProfitQuery, useCreateDealerAddressProfitMutation, useUpdateDealerAddressProfitMutation, useGetByIdDealerAddressProfitQuery } from './endpoints/dealerAddressBrandProfit';

export {
    useGetAllDealerAddressBrandAuthSrcTypeQuery,
    useGetByIdDealerAddressBrandAuthSrcTypeQuery,
    useCreateDealerAddressBrandAuthSrcTypeMutation,
    useUpdateDealerAddressBrandAuthSrcTypeMutation,
    useDeleteDealerAddressBrandAuthSrcTypeMutation
} from './endpoints/dealerAddressBrandAuthSrcType';

export { useGetAllDealerAddressBrandRegionalManagerQuery, useCreateDealerAddressBrandRegionalManagerMutation, useUpdateDealerAddressBrandRegionalManagerMutation } from './endpoints/dealerAddressBrandRegionalManager';

export {
    useGetAllDealerAdressBrandTechnicalSupportResponsibleQuery,
    useCreateDealerAdressBrandTechnicalSupportResponsibleMutation,
    useUpdateDealerAdressBrandTechnicalSupportResponsibleMutation,
    useDeleteDealerAdressBrandTechnicalSupportResponsibleMutation,
    useGetByIdDealerAdressBrandTechnicalSupportResponsibleQuery
} from './endpoints/dealerAdressBrandTechnicalSupportResponsible';

export {
    useGetAllDealerAddressBrandAddrReportQuery,
    useCreateDealerAddressBrandAddrReportMutation,
    useUpdateDealerAddressBrandAddrReportMutation,
    useGetInterserviceDropdownListQuery,
    useGetInterserviceAddrDropdownListQuery,
    useGetDealerAddrDropdownListQuery
} from './endpoints/dealerAddressBrandAddrReport';

export { useGetAllDealerAgreementTypeQuery, useGetByIdDealerAgreementTypeQuery, useCreateDealerAgreementTypeMutation, useUpdateDealerAgreementTypeMutation, useDeleteDealerAgreementTypeMutation } from './endpoints/dealerAgreementType';

export {
    useSaveDealerRegistrationMutation,
    useUpdateDealerRegistrationMutation,
    useSendDealerRegistrationToApprovalMutation,
    useGetDealerRegistrationListQuery,
    useLazyGetDealerRegistrationListQuery,
    useGetDealerFilterListQuery,
    useLazyGetDealerFilterListQuery,
    useGetDealerRegistrationByIdQuery,
    useLazyGetDealerRegistrationByIdQuery
} from './endpoints/dealerRegistration';

export {
    useGetDealerApprovalInboxQuery,
    useLazyGetDealerApprovalInboxQuery,
    useGetDealerApprovalByIdQuery,
    useLazyGetDealerApprovalByIdQuery,
    useApproveDealerApprovalMutation,
    useRejectDealerApprovalMutation,
    useReturnDealerApprovalMutation
} from './endpoints/dealerApproval';

export { useGetDealerAddressUsersQuery } from './endpoints/dealerAddressUsers';

export {
    useCreateFullServiceInvoiceMutation,
    useGetFullServiceInvoiceByIdQuery,
    useUpdateFullServiceInvoiceMutation,
    useDeleteFullServiceInvoiceMutation,
    useGetFullServiceInvoicesQuery,
    useSendFullServiceToSapMutation,
    useLazyGetCurrencyByDealerIdQuery
} from './endpoints/fullServiceInvoice';
export { useCreateFullServiceKmMutation, useGetFullServiceKmByIdQuery, useUpdateFullServiceKmMutation, useDeleteFullServiceKmMutation, useGetFullServiceKmQuery, useChangeFullServiceKmStatusMutation } from './endpoints/fullServiceKm';

export { useGetLookUpDropdownListQuery } from './endpoints/lookup';
export { useGetAllLanguagesQuery } from './endpoints/language';
export { useGetTranslationDataQuery } from './endpoints/translation';
export {
    useGetAllWarrantyClaimsQuery,
    useCreateWarrantyClaimsMutation,
    useGetWarrantyClaimsByIdQuery,
    useUpdateWarrantyClaimsMutation,
    useDeleteWarrantyClaimsMutation,
    useWarrantyClaimsApprovementMutation,
    useWarrantyClaimsReturnMutation,
    useBulkApproveSimpleMutation,
    useAddWarrantyClaimsItemMutation,
    useGetWarrantyClaimsItemListQuery,
    useGetWarrantyClaimsItemByIdQuery,
    useUpdateWarrantyClaimsItemMutation,
    useDeleteWarrantyClaimsItemMutation,
    useGetWarrantyClaimsLaborListQuery,
    useGetWarrantyClaimsLaborByIdQuery,
    useAddWarrantyClaimsLaborMutation,
    useUpdateWarrantyClaimsLaborMutation,
    useDeleteWarrantyClaimsLaborMutation,
    useAddWarrantyClaimsOtherCostMutation,
    useGetWarrantyClaimsOtherCostByIdQuery,
    useGetWarrantyClaimsOtherCostListQuery,
    useUpdateWarrantyClaimsOtherCostMutation,
    useDeleteWarrantyClaimsOtherCostMutation,
    useLazyGetWarrantyClaimsOtherCostItemPdfQuery,
    useUploadWarrantyClaimDocumentMutation,
    useDeleteWarrantyClaimDocumentMutation,
    useGetWarrantyClaimDocumentsByIdQuery,
    useGetWarrantyClaimsListBySapDealerIdQuery,
    useGetWarrantyClaimsHistoryQuery,
    useCalculateWarrantyClaimTotalsQuery,
    useGetApprovalCommentsByClaimIdQuery,
    useGetExternalPartsQuery,
    useLazyCalculateLaborCostQuery,
    useLazyExportWarrantyClaimsQuery,
    useGetWarrantyWarningByChassisQuery,
    useUpdateMaterialCostTypeMutation,
    useGetWarrantyClaimsStatusCountsQuery
} from './endpoints/warrantyClaims';

export {
    useGetAllVehicleWarrantyPeriodQuery,
    useLazyGetVehicleWarrantyPeriodByIdQuery,
    useUpdateVehicleWarrantyPeriodMutation,
    useUploadVehicleWarrantyPeriodDocumentMutation,
    useLazyGetVehicleWarrantyPeriodDocumentsByIdQuery,
    useDeleteDocumentVehicleWarrantyPeriodMutation
} from './endpoints/vehicleWarrantyPeriod';

export {
    useGetAllPreStockInspectionQuery,
    useCreatePreStockInspectionMutation,
    useGetAllQuestionQuery,
    useGetByIdPreStockInspectionsQuery,
    useUpdatePreStockInspectionMutation,
    useCheckVafExistsQuery,
    useSentToKarsanMutation,
    useGetChassisListForPSIQuery,
    useGetPreStockInspectionHistoryQuery
} from './endpoints/preStockInspection';
export { useGetChassisListQuery } from './endpoints/addperiod';

export {
    useGetAllVehicleRegistrationFormQuery,
    useCreateVehicleRegistrationFormMutation,
    useCheckChassisNoQuery,
    useGetByIdVehicleRegistrationFormQuery,
    useUpdateVehicleRegistrationFormMutation,
    useDeleteVehicleRegistrationFormMutation,
    useChangeStatusVehicleRegistrationFormMutation,
    useUploadVehicleRegistrationDocumentMutation,
    useUpdateVehicleRegistrationDocumentMutation,
    useGetDocumentsByVehicleRegistrationFormIdQuery,
    useDeleteVehicleRegistrationDocumentMutation,
    useGetChassisListForCVRFQuery,
    useGetVehicleRegistrationFormHistoryQuery
} from './endpoints/vehicleRegistrationForm';
export {
    useGetListVehicleAcceptanceFormQuery,
    useGetVehicleAcceptanceFormByIdQuery,
    useAddVehicleAcceptanceFormMutation,
    useUpdateVehicleAcceptanceFormMutation,
    useDeleteVehicleAcceptanceFormMutation,
    useCheckActiveByChasisNoQuery,
    useApprovementVehicleAcceptanceFormMutation,
    useUploadDocumentMutation,
    useGetDocumentsByIdQuery,
    useLazyGetDocumentsByIdQuery,
    useDeleteDocumentMutation,
    useGetVehicleAcceptanceFormHistoryQuery
} from './endpoints/vehicleAcceptenceForm';
export {
    useGetDealerAddressOrderTypeListQuery,
    useGetDealerAddressOrderTypeByIdQuery,
    useAddDealerAddressOrderTypeMutation,
    useUpdateDealerAddressOrderTypeMutation,
    useDeleteDealerAddressOrderTypeMutation,
    useGetDealerAddressOrderTypeSapListQuery
} from './endpoints/dealerAddressOrderType';
export { useGetWaybillShipmentsQuery, useGetUnpickedPartsQuery, useLazyExportUnpickedPartsToExcelQuery } from './endpoints/parts';
export { useGetApprovalLimitGroupsQuery, useGetApprovalLimitGroupByIdQuery, useCreateApprovalLimitGroupMutation, useUpdateApprovalLimitGroupMutation } from './endpoints/approvalLimitGroups';
export { useGetApprovalLimitsQuery, useGetApprovalLimitByIdQuery, useCreateApprovalLimitMutation, useUpdateApprovalLimitMutation } from './endpoints/approvalLimits';
export {
    useGetWarrantyPeriodAllQuery,
    useGetWarrantyPeriodByIdQuery,
    useCreateWarrantyPeriodAsyncMutation,
    useUpdateWarrantyPeriodMutation,
    useDeleteWarrantyPeriodMutation,
    useGetProductGroupsDropdownListQuery,
    useGetVehicleItemsDropdownListQuery
} from './endpoints/warrantyPeriodApi';

export {
    useGetAnnouncementTypeAllQuery,
    useGetAnnouncementTypeByIdQuery,
    useCreateAnnouncementTypeAsyncMutation,
    useUpdateAnnouncementTypeMutation,
    useDeleteAnnouncementTypeMutation,
    useAnnouncementTypeDropdownQuery
} from './endpoints/announcementTypeApi';

export { useGetLmsLookupTranslationsQuery, useGetLmsLookupTranslationByIdQuery, useAddLmsLookupTranslationMutation, useUpdateLmsLookupTranslationMutation, useDeleteLmsLookupTranslationMutation } from './endpoints/lmsLookupTranslation';

export { useGetLmsVehicleTrainingMatchesQuery } from './endpoints/lmsVehicleTrainingMatch';

export { useGetLmsVehicleTrainingMatchListQuery, useCreateLmsVehicleTrainingMatchMutation, useUpdateLmsVehicleTrainingMatchMutation, useDeleteLmsVehicleTrainingMatchMutation } from './endpoints/lmsVehicleTrainingMatch';

export { useGetLmsTrainingDocumentsQuery, useAddLmsTrainingDocumentMutation, useUpdateLmsTrainingDocumentMutation, useDeleteLmsTrainingDocumentMutation } from './endpoints/lmsTrainingDocument';

export {
    useGetLmsTrainingCatalogsQuery,
    useGetLmsTrainingCatalogDropdownQuery,
    useGetLmsTrainingCatalogByIdQuery,
    useGetLmsTrainingCatalogDetailByIdQuery,
    useAddLmsTrainingCatalogMutation,
    useUpdateLmsTrainingCatalogMutation,
    useDeleteLmsTrainingCatalogMutation
} from './endpoints/lmsTrainingCatalog';

export {
    useGetLmsTrainingInstructorsQuery,
    useGetLmsTrainingInstructorByIdQuery,
    useAddLmsTrainingInstructorMutation,
    useUpdateLmsTrainingInstructorMutation,
    useDeleteLmsTrainingInstructorMutation
} from './endpoints/lmsTrainingInstructor';

export {
    useGetLmsTrainingContentOutputsQuery,
    useGetLmsTrainingContentOutputByTrainingIdQuery,
    useAddLmsTrainingContentOutputMutation,
    useUpdateLmsTrainingContentOutputMutation,
    useDeleteLmsTrainingContentOutputMutation
} from './endpoints/lmsTrainingContentOutput';

export { useGetLmsPreconditionsQuery, useGetLmsPreconditionByIdQuery, useAddLmsPreconditionMutation, useUpdateLmsPreconditionMutation, useDeleteLmsPreconditionMutation } from './endpoints/lmsPrecondition';

export {
    useGetLmsTrainingPreconditionsQuery,
    useGetLmsTrainingPreconditionByIdQuery,
    useAddLmsTrainingPreconditionMutation,
    useUpdateLmsTrainingPreconditionsMutation,
    useDeleteLmsTrainingPreconditionMutation
} from './endpoints/lmsTrainingPrecondition';

export { useGetLmsCatalogPlanningsQuery, useGetLmsCatalogPlanningByIdQuery, useAddLmsCatalogPlanningMutation, useUpdateLmsCatalogPlanningMutation, useDeleteLmsCatalogPlanningMutation } from './endpoints/lmsCatalogPlanning';

export { useGetLmsPlanningInstructorsQuery, useGetLmsPlanningInstructorByIdQuery, useAddLmsPlanningInstructorMutation, useUpdateLmsPlanningInstructorMutation, useDeleteLmsPlanningInstructorMutation } from './endpoints/lmsPlanningInstructor';

export {
    useGetLmsTrainingReportsQuery,
    useGetLmsTrainingReportByIdQuery,
    useGetLmsTrainingReportDetailByIdQuery,
    useAddLmsTrainingReportMutation,
    useUpdateLmsTrainingReportMutation,
    useDeleteLmsTrainingReportMutation
} from './endpoints/lmsTrainingReport';

export {
    useGetLmsTrainingReportCostsQuery,
    useGetLmsTrainingReportCostByIdQuery,
    useAddLmsTrainingReportCostMutation,
    useUpdateLmsTrainingReportCostMutation,
    useDeleteLmsTrainingReportCostMutation
} from './endpoints/lmsTrainingReportCost';

export {
    useGetLmsTrainingReportParticipantsQuery,
    useGetLmsTrainingReportParticipantByIdQuery,
    useAddLmsTrainingReportParticipantMutation,
    useUpdateLmsTrainingReportParticipantMutation,
    useDeleteLmsTrainingReportParticipantMutation
} from './endpoints/lmsTrainingReportParticipant';

export {
    useGetLmsTrainingReportInstructorsQuery,
    useGetLmsTrainingReportInstructorByIdQuery,
    useAddLmsTrainingReportInstructorMutation,
    useUpdateLmsTrainingReportInstructorMutation,
    useDeleteLmsTrainingReportInstructorMutation
} from './endpoints/lmsTrainingReportInstructor';

export {
    useGetLmsCreateRequestsQuery,
    useGetLmsCreateRequestByIdQuery,
    useAddLmsCreateRequestMutation,
    useUpdateLmsCreateRequestMutation,
    useDeleteLmsCreateRequestMutation,
    useGetApplicableFeeQuery,
    useGetTrainingTypesByVehicleModelQuery,
    useGetVehicleModelsWithUpcomingPlanningsQuery,
    useGetLmsCreateRequestPlanningsQuery,
    useChangeLmsCreateRequestStatusMutation,
    useGetLmsCreateRequestCommentsQuery,
    useCalculateLmsCreateRequestEndDateMutation
} from './endpoints/lmsCreateRequest';

export {
    useGetLmsTenderRequestsQuery,
    useGetLmsTenderRequestByIdQuery,
    useAddLmsTenderRequestMutation,
    useUpdateLmsTenderRequestMutation,
    useDeleteLmsTenderRequestMutation,
    useCalculateLmsTenderRequestEndDateMutation
} from './endpoints/lmsTenderRequest';

export {
    useGetLmsVideoListQuery,
    useLazyGetLmsVideoListQuery,
    useGetLmsVideoByIdQuery,
    useLazyGetLmsVideoByIdQuery,
    useAddLmsVideoMutation,
    useUpdateLmsVideoMutation,
    useDeleteLmsVideoMutation,
    useGenerateLmsVideoUploadUrlMutation,
    useCompleteLmsVideoUploadMutation,
    useGetLmsVideoDownloadUrlQuery,
    useLazyGetLmsVideoDownloadUrlQuery
} from './endpoints/lmsVideo';

export {
    useGetLmsActiveNewsQuery,
    useGetLmsAllNewsQuery,
    useGetLmsNewsByIdQuery,
    useGetLmsNewsByPlanningIdQuery,
    useGetLmsNewsPhotoQuery,
    useAddLmsNewsMutation,
    useUpdateLmsNewsMutation,
    useDeleteLmsNewsMutation,
    useUploadLmsNewsPhotoMutation,
    useDeleteLmsNewsPhotoMutation
} from './endpoints/lmsNews';

export { useGetLmsDashboardStatisticsQuery, useGetLmsDashboardCalendarQuery, useGetLmsDashboardUpcomingTrainingsQuery } from './endpoints/lmsDashboard';

export { useGetUserGroupsQuery, useGetUserByDealerDropdownQuery, useGetUserParamsQuery } from './endpoints/user';
export { useGetVehicleItemsQuery } from './endpoints/vehicleItemsApi';

export {
    useDownloadDocumentQuery,
    useGetDownloadUrlQuery,
    useGetPreviewUrlQuery,
    useGetDownloadUrlByKeyQuery,
    useDownloadByKeyQuery,
    useLazyDownloadDocumentQuery,
    useLazyGetDownloadUrlQuery,
    useLazyGetPreviewUrlQuery,
    useLazyGetDownloadUrlByKeyQuery,
    useLazyDownloadByKeyQuery,
    useUploadDocumentContentMutation,
    useDownloadDocumentByKeyQuery,
    useLazyDownloadDocumentByKeyQuery
} from './endpoints/documentContent';

export {
    useGetListAdministrationPagesQuery,
    useGetAdministrationPageByIdQuery,
    useSaveAdministrationPageMutation,
    useUpdateAdministrationPageMutation,
    useDeleteAdministrationPageMutation,
    useGetUserListQuery,
    useGetRoleListQuery,
    useLazyGetUserListQuery,
    useLazyGetRoleListQuery
} from './endpoints/administratorPage';

export { useGetManagerRoleClaimListQuery, useAddManagerRoleClaimMutation, useRemoveManagerRoleClaimMutation, useGetSuperAdminUserListQuery } from './endpoints/superAdminDefinition';

export { useGetAllCountriesQuery, useGetCountryByKunnrQuery } from './endpoints/country';

export { useGetBasketQuery, useAddOrUpdateBasketMutation, useRemoveFromBasketMutation, useClearBasketMutation } from './endpoints/basket';

export { useGetWarehousesQuery, useCreateWarehouseMutation, useUpdateWarehouseMutation, useDeleteWarehouseMutation, useGetWarehouseTypesQuery, useGetParentWarehousesQuery } from './endpoints/dealerWarehouse';

export { useGetStocksQuery, useGetStockLogsQuery } from './endpoints/dealerStockReport';

export { useGetDealerStockListQuery } from './endpoints/dealerPartsReturnProcess';

export { useGetInvoiceApprovalsQuery, useGetInvoiceApprovalByIdQuery, useGetInvoiceApprovalHistoryQuery, useLazyGetInvoiceApprovalHistoryQuery, useUpdateInvoiceApprovalMutation } from './endpoints/invoiceApproval';

export {
    useGetDeclarationsQuery,
    useLazyGetDeclarationsQuery,
    useGetDeclarationByIdQuery,
    useLazyGetDeclarationByIdQuery,
    useGetDeclarationReportByIdQuery,
    useLazyGetDeclarationReportByIdQuery,
    useAddDeclarationMutation,
    useUpdateDeclarationMutation,
    useDeleteDeclarationMutation,
    useCloseDeclarationMutation,
    useGetCustomerStatementHistoryQuery,
    useLazyGetChassisDetailQuery,
    useGetChassisDetailQuery,
    useMarkOpenDocumentPrintedMutation,
    useLazyExportToExcelQuery,
    useUploadRepairDocumentMutation,
    useGetRepairDocumentsByIdQuery,
    useLazyGetRepairDocumentsByIdQuery,
    useLazyGetWarrantClaimsForRepairCloseQuery,
    useUpsertRepairCloseInvoiceMutation,
    useLazyGetCustomerDiscountRatesQuery,
    useRepairClosingToAccountingMutation,
    useUndoRepairCloseAccountingMutation,
    useGetDraftWarrantyClaimsQuery,
    useLazyGetDraftWarrantyClaimsQuery
} from './customerDeclarationApi';

export { useGetOrderListQuery } from './endpoints/orders';

export { useGetPackagesQuery, useLazyGetPackagesQuery, useGetPackageByIdQuery, useLazyGetPackageByIdQuery, useCreatePackageMutation, useUpdatePackageMutation, useFetchPartsQuery, useLazyFetchPartsQuery } from './endpoints/packageDefinitionsApi';

export { useGetWarrantyReportQuery, useGetPartReplacementDetailsQuery, useLazyExportAllClaimsReportsQuery, useLazyExportDealerChassisCostsQuery, useLazyExportMostReplacedPartsQuery } from './endpoints/warrantyReports';

export { useGetWarrantyDashboardQuery } from './endpoints/warrantyDashboard';

export { useGetBulletinFileListQuery, useLazyDownloadBulletinFileQuery } from './endpoints/bulletinDocument';

export { useGetCurrentAccountReportQuery, useLazyExportCurrentAccountReportToExcelQuery } from './endpoints/currentAccountReport';

export { useGetCollectionReportQuery, useLazyExportCollectionReportQuery } from './endpoints/collectionReport';

export { useGetVehicleParkReportQuery, useLazyExportVehicleParkToExcelQuery } from './endpoints/vehicleParkReport';

export { useGetDealersStockByDealerIdQuery, useGetDealerPartHistoryQuery } from './endpoints/dealersStockView';

export { useGetMatnrIntegrationStatusListMutation } from './endpoints/matnrIntegrationStatusReport';

export {
    useGetMyAddedStockLogsQuery,
    useGetDealerStockDealerDropdownQuery,
    useLazyGetDealerStockDealerDropdownQuery,
    useGetDealerStockWarehouseDropdownQuery,
    useLazyGetDealerStockWarehouseDropdownQuery,
    useGetDealerStockPartDropdownQuery,
    useLazyGetDealerStockPartDropdownQuery,
    useAddDealerStockMutation
} from './endpoints/dealerStockAdd';

export {
    useGetPartDefinitionsQuery,
    useLazyGetPartDefinitionsQuery,
    useGetPriceInformationQuery,
    useGetPriceHistoryQuery,
    useLazyGetPriceInformationQuery,
    useGetStockInformationListQuery,
    useLazyGetStockInformationListQuery,
    useGetStockHistoryListQuery,
    useGetStockByPartCodeQuery
} from './endpoints/dealerPartsCatalog';

export {
    useGetApprovalOrdersQuery,
    useLazyGetApprovalOrdersQuery,
    useUpdateProductQuantityMutation,
    useRemoveProductMutation,
    useApproveOrRejectOrderMutation,
    useGetApprovalOrderDetailsQuery,
    useLazyGetApprovalOrderDetailsQuery
} from './endpoints/approvalOrders';

export { useGetTechnicalSupportRequestsQuery, useUploadTechnicalSupportRequestDocumentMutation, useGetTechnicalSupportRequestDocumentsByIdQuery, useDeleteTechnicalSupportRequestDocumentMutation } from './endpoints/technicalSupportRequest';

export { useGetExternalVehiclesQuery, useGetExternalVehicleByIdQuery, useLazyGetExternalVehicleByIdQuery, useCreateExternalVehicleMutation, useUpdateExternalVehicleMutation, useDeleteExternalVehicleMutation } from './endpoints/externalVehicle';

export { useGetAllDealerOtherLaborPriceQuery, useCreateDealerOtherLaborPriceMutation, useUpdateDealerOtherLaborPriceMutation, useDeleteDealerOtherLaborPriceMutation } from './endpoints/dealerOtherLaborPrice';

export { useGetInstallmentOptionsQuery, useLazyGetInstallmentOptionsQuery, useProcessPaymentMutation, useValidateCardBinQuery, useLazyValidateCardBinQuery, useLazyExportPaymentReportsQuery } from './endpoints/creditCardPayment';

export { useGetCariReportDetailQuery, useLazyGetCariReportDetailQuery, useLazyExportCariReportDetailQuery } from './endpoints/accountingReport';

export const {
    useGetAvailableSapDocumentsQuery,
    useGetAllAvailableSapDocumentsForWarrantyTeamQuery,
    useGetDealerInvoiceHistoryQuery,
    useCreateDealerInvoiceMutation,
    useUpdateDealerInvoiceMutation,
    useUploadInvoiceDocumentMutation,
    useGetInvoiceDocumentByIdQuery,
    useLazyGetInvoiceDocumentByIdQuery,
    useDeleteInvoiceDocumentMutation,
    useGetPendingApprovalsForWarrantyTeamQuery,
    useGetApprovalDetailQuery,
    useApproveDealerInvoiceMutation,
    useRejectDealerInvoiceMutation,
    useReturnDealerInvoiceMutation,
    useGetInvoiceDetailByGroupIdQuery,
    useLazyGetInvoiceDetailByGroupIdQuery
} = dealerInvoiceEntryApi;

export {
    useLazyGetDraftListQuery,
    useLazyGetPendingApprovalListQuery,
    useLazyGetApprovedListQuery,
    useLazyGetRejectedListQuery,
    useLazyGetOrderDetailQuery,
    useLazyGetAvailableChassisQuery,
    useSubmitForApprovalMutation,
    useUpdateDraftMutation,
    useProcessApprovalMutation,
    useApproveByLogisticsMutation,
    useGetVehicleStockListQuery,
    useUpdateVehicleStockSellableMutation,
    useSellVehicleStockToCustomerMutation
} from './endpoints/vehicleOrder';

export {
    useGetSaleListingListQuery,
    useLazyGetSaleListingListQuery,
    useGetSaleListingDetailQuery,
    useLazyGetSaleListingDetailQuery,
    useGetMyPurchaseRequestsQuery,
    useLazyGetMyPurchaseRequestsQuery,
    useGetDealerFilterOptionsQuery,
    useCreatePurchaseRequestMutation,
    useCancelPurchaseRequestMutation,
    useProcessPurchaseRequestMutation
} from './endpoints/vehicleSale';

export { useGetClaimHistoryReportQuery, useLazyExportClaimHistoryToExcelQuery } from './endpoints/claimHistoryReport';
export { useGetPreAppHistoryReportQuery, useLazyExportPreAppHistoryToExcelQuery } from './endpoints/preAppHistoryReport';
export { useGetDealerProcessingReportQuery, useLazyExportDealerProcessingToExcelQuery } from './endpoints/dealerProcessingReport';
export { useGetRepairSlipReportQuery, useLazyGetRepairSlipReportQuery, useLazyExportRepairSlipReportToExcelQuery } from './endpoints/repairSlipReport';
export { useGetVehicleDistributionReportQuery, useLazyExportVehicleDistributionToExcelQuery } from './endpoints/vehicleDistributionReport';
export { useGetVehicleSaleReportQuery, useLazyExportVehicleSaleReportToExcelQuery } from './endpoints/vehicleSaleReport';
export {
    useGetRefundInitialDataQuery,
    useLazyGetRefundInitialDataQuery,
    useGetRefundDraftListQuery,
    useLazyGetRefundDraftListQuery,
    useGetRefundPendingApprovalListQuery,
    useLazyGetRefundPendingApprovalListQuery,
    useGetRefundApprovedListQuery,
    useLazyGetRefundApprovedListQuery,
    useGetRefundRejectedListQuery,
    useLazyGetRefundRejectedListQuery,
    useGetRefundOrderDetailQuery,
    useLazyGetRefundOrderDetailQuery,
    useCreateRefundDraftMutation,
    useUpdateRefundDraftMutation,
    useSubmitRefundForApprovalMutation,
    useProcessRefundApprovalMutation
} from './endpoints/vehicleRefundOrder';
export { useGetVehicleServiceReportQuery, useLazyExportVehicleServiceToExcelQuery } from './endpoints/vehicleServiceReport';
export {
    useGetBlockShelfSeqItemDescriptionsQuery,
    useLazyExportBlockShelfSeqItemDescriptionsToExcelQuery,
    useCreateBlockShelfSeqItemDescriptionMutation,
    useUpdateBlockShelfSeqItemDescriptionMutation,
    useDeleteBlockShelfSeqItemDescriptionMutation
} from './endpoints/itemDescriptions';
export { useLazyGetMaterialCatalogDetailQuery, useLazyGetMaterialCatalogMovementQuery, useLazyGetMaterialCatalogOtherCompanyQuery } from './endpoints/materialCatalog';

export { useGetTablePreferenceQuery, useLazyGetTablePreferenceQuery, useGetMyTablePreferencesQuery, useUpsertTablePreferenceMutation, useResetTablePreferenceMutation } from './endpoints/userTablePreferences';

export { useGetMatnrPartsPriceReportQuery, useLazyExportMatnrPartsPriceToExcelQuery } from './endpoints/matnrPartsPriceReport';

export {
    useGetWarrantyAuditCriteriaQuery,
    useLazyGetWarrantyAuditCriteriaQuery,
    useCreateWarrantyAuditCriteriaMutation,
    useUpdateWarrantyAuditCriteriaMutation,
    useDeleteWarrantyAuditCriteriaMutation,
    useCreateWarrantyAuditSubCriteriaMutation,
    useUpdateWarrantyAuditSubCriteriaMutation,
    useDeleteWarrantyAuditSubCriteriaMutation,
    useCreateWarrantyAuditEvaluationMutation,
    useUpdateWarrantyAuditEvaluationMutation,
    useDeleteWarrantyAuditEvaluationMutation,
    useGetWarrantyAuditTemplateQuery,
    useGetWarrantyAuditScoreBandsQuery,
    useCreateWarrantyAuditResultMutation,
    useUploadWarrantyAuditDocumentMutation,
    useGetWarrantyAuditDocumentsByIdQuery,
    useDeleteWarrantyAuditDocumentMutation,
    useGetWarrantyAuditResultsQuery,
    useGetWarrantyAuditResultByIdQuery,
    useLazyGetWarrantyAuditResultByIdQuery,
    useGetWarrantyAuditHistoryQuery,
    useLazyGetWarrantyAuditHistoryQuery,
    useGetWarrantyAuditPdfDataQuery,
    useLazyGetWarrantyAuditPdfDataQuery
} from './endpoints/warrantyAudit';

// Export Form Date Change Request API hooks
export {
    useGetFormDateChangeRequestListQuery,
    useLazyGetFormDateChangeRequestListQuery,
    useGetFormDateChangeRequestByIdQuery,
    useLazyGetFormDateChangeRequestByIdQuery,
    useAddFormDateChangeRequestMutation,
    useApproveFormDateChangeRequestMutation
} from './endpoints/formDateChangeRequest';

export {
    useGetAllTeamProductivityMeasurementQuery,
    useGetTeamProductivityMeasurementByIdQuery,
    useCreateTeamProductivityMeasurementMutation,
    useUpdateTeamProductivityMeasurementMutation,
    useCompleteTeamProductivityMeasurementMutation,
    useGetRequestTypeDropdownQuery,
    useGetRequestBroadChannelDropdownQuery,
    useGetRequestSenderDropdownQuery,
    useGetVorVehicleDropdownQuery,
    useGetOldRequestNumberDropdownQuery,
    useGetPersonsByGroupDropdownQuery,
    useLazyGetPersonsByGroupDropdownQuery
} from './endpoints/teamProductivityMeasurement';
